import { Globe, Server, Shield, Terminal } from 'lucide-react'
import type { FloatingIconItem } from '@/components/ui/floating-icons-hero-section'
import {
  IconBinance,
  IconCalendar,
  IconDiscord,
  IconFigma,
  IconGitHub,
  IconGoogle,
  IconGroww,
  IconLinear,
  IconMicrosoft,
  IconNotion,
  IconSlack,
  IconSpotify,
  IconStripe,
  IconTwitter,
  IconVercel,
  IconYouTube,
} from './connect-platform-brand-icons'

/** baby: Colored brand tiles for Ningenie /home: layout mirrors reference demo */
export const NINGENIE_CONNECT_PLATFORM_ICONS: FloatingIconItem[] = [
  { id: 1, icon: IconGoogle, className: 'top-[10%] left-[10%]', tileBackgroundColor: '#4285F415' },
  { id: 2, icon: IconSlack, className: 'top-[20%] right-[8%]', tileBackgroundColor: '#36C5F015' },
  { id: 3, icon: IconGitHub, className: 'top-[80%] left-[10%]', iconColor: '#181717', tileBackgroundColor: '#18171715' },
  { id: 4, icon: IconFigma, className: 'bottom-[10%] right-[10%]', tileBackgroundColor: '#A259FF15' },
  { id: 5, icon: Terminal, className: 'top-[5%] left-[30%]', iconColor: '#334155', tileBackgroundColor: '#33415515' },
  { id: 6, icon: Globe, className: 'top-[5%] right-[30%]', iconColor: '#0284C7', tileBackgroundColor: '#0284C715' },
  { id: 7, icon: IconVercel, className: 'bottom-[8%] left-[25%]', iconColor: '#111827', tileBackgroundColor: '#11182710' },
  { id: 8, icon: IconStripe, className: 'top-[40%] left-[15%]', tileBackgroundColor: '#635BFF15' },
  { id: 9, icon: IconDiscord, className: 'top-[75%] right-[25%]', tileBackgroundColor: '#5865F215' },
  { id: 10, icon: IconTwitter, className: 'top-[90%] left-[70%]', iconColor: '#111827', tileBackgroundColor: '#11182710' },
  { id: 11, icon: IconNotion, className: 'top-[50%] right-[5%]', iconColor: '#111827', tileBackgroundColor: '#11182712' },
  { id: 12, icon: IconSpotify, className: 'top-[55%] left-[5%]', tileBackgroundColor: '#1DB95415' },
  { id: 13, icon: IconMicrosoft, className: 'top-[5%] left-[55%]', tileBackgroundColor: '#00A4EF15' },
  { id: 14, icon: IconYouTube, className: 'bottom-[5%] right-[45%]', tileBackgroundColor: '#FF000015' },
  { id: 15, icon: IconLinear, className: 'top-[25%] right-[20%]', tileBackgroundColor: '#5E5CE615' },
  { id: 16, icon: IconCalendar, className: 'top-[60%] left-[30%]', tileBackgroundColor: '#4285F415' },
  { id: 17, icon: IconGroww, className: 'top-[48%] right-[4%]', tileBackgroundColor: '#387ED115' },
  { id: 18, icon: IconBinance, className: 'top-[58%] left-[28%]', tileBackgroundColor: '#F0B90B15' },
  { id: 19, icon: Shield, className: 'top-[4%] left-[52%]', iconColor: '#10B981', tileBackgroundColor: '#10B98115' },
  { id: 20, icon: Server, className: 'bottom-[6%] right-[42%]', iconColor: '#6366F1', tileBackgroundColor: '#6366F115' },
]
